import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import { InvoiceOperationResult } from "../../entities/InvoiceEntity";

/**
 * Update Invoice Status Use Case
 * Updates the status of an invoice
 */
export class UpdateInvoiceStatusUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(
    invoiceId: number,
    status: number
  ): Promise<InvoiceOperationResult> {
    // Validate invoice ID
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    // // Validate status (0-10)
    // if (status < 0 || status > 10) {
    //   throw new Error("Status must be between 0 and 10");
    // }

    return await this.repository.updateInvoiceStatus(invoiceId, status);
  }
}
